import { CanvasLayer } from '@y42/json-schema';

export const layersZIndex: Record<CanvasLayer, number> = {
  [CanvasLayer.Frames]: -100000,
  [CanvasLayer.Default]: 0,
  [CanvasLayer.EmojiNodes]: 100000,
  [CanvasLayer.AttentionNodes]: 200000,
  [CanvasLayer.CommentPins]: 300000,
};
